/* TBS · Carrito lateral: añadir rápido desde "Complete the look" */
(function () {
  if (window.__tbsCartReady) return;
  window.__tbsCartReady = true;

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function closeSizes(except) {
    document.querySelectorAll('cart-drawer [data-tbs-cart-toggle][aria-expanded="true"]').forEach(function (btn) {
      if (btn === except) return;
      btn.setAttribute('aria-expanded', 'false');
      var panel = btn.parentElement.querySelector('.tbs-up__sizes');
      if (panel) panel.hidden = true;
    });
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-tbs-cart-toggle]');
    if (toggle && toggle.closest('cart-drawer')) {
      event.preventDefault();
      var open = toggle.getAttribute('aria-expanded') === 'true';
      closeSizes(toggle);
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      var panel = toggle.parentElement.querySelector('.tbs-up__sizes');
      if (panel) panel.hidden = open;
      return;
    }

    var add = event.target.closest('[data-tbs-cart-add]');
    if (!add || !add.closest('cart-drawer') || add.disabled) return;
    event.preventDefault();
    quickAdd(add);
  });

  function quickAdd(button) {
    var cart = drawer();
    var card = button.closest('.tbs-up');
    var message = card ? card.querySelector('[data-tbs-cart-msg]') : null;
    var body = new FormData();
    body.append('id', button.dataset.tbsCartAdd);
    body.append('quantity', '1');
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.append(
        'sections',
        cart.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      body.append('sections_url', window.location.pathname);
    }

    if (message) message.hidden = true;
    button.classList.add('is-loading');
    button.disabled = true;

    function fail(text) {
      button.classList.remove('is-loading');
      button.disabled = false;
      if (message) {
        message.textContent = text || 'Could not add this item.';
        message.hidden = false;
      }
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: body,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          fail(response.description || response.message);
          return;
        }
        if (!cart || typeof cart.renderContents !== 'function') {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        cart.classList.remove('is-empty');
        cart.renderContents(response);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'tbs-cart-upsell',
            productVariantId: button.dataset.tbsCartAdd,
            cartData: response,
          });
        }
      })
      .catch(function (error) {
        console.error(error);
        fail();
      });
  }
})();
